import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SettingList from './SettingList.jsx';
import TopicForm from './TopicForm.jsx';
import { deleteTopic } from '../../lib/redux/actions.jsx';
import DeleteModal from './DeleteModal.jsx';
import TopicsModal from './TopicsModal.jsx';

const TopicsList = () => {
  const { t } = useTranslation(['edit']);
  const topics = useSelector(state => state.status.ribbonTags);
  const dispatch = useDispatch();
  const deleteTexts = [
    t('edit:topicsList:deleteTopicPhrase1'),
    t('edit:topicsList:deleteTopicPhrase2'),
  ];

  const onDelete = item => {
    return DeleteModal({
      phrases: deleteTexts,
      onCancel: () => TopicsModal(),
      onConfirm: () => {
        dispatch(deleteTopic(item));
        TopicsModal();
      },
    });
  };

  return (
    <SettingList
      collection={topics}
      settingName={t('edit:topicsList:settingName')}
      form={TopicForm}
      onDelete={onDelete}
    />
  );
};

export default TopicsList;
